/**
 * Load `$localize` onto the global scope — used if i18n tags appear in Angular templates.
 */
import "@angular/localize/init";

/**
 * Zone.js is required by Angular itself.
 */
import "zone.js";

if (typeof SVGElement.prototype.contains === "undefined") {
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}
